import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './KWittBookingDetails.html?raw';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
import Button from '../../../../moreCore/UI/Button/Button';
import { ToasterHelpers } from "../../../../more/Helpers";


interface KWittCalendar_ItemDetails {
    content: string,
    filesDetails?: Array<KWittCalendar_FileDetails>,
    show_download_travel_list_button: boolean
}

interface KWittCalendar_FileDetails {
    fileName?: string,
    downloadKey?: string
}
class KWittBookingDetails extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private itemData: KWittCalendar_ItemDetails = null;
    itemId: string = null;
    assignedEntities: any = null;

    areBookedDocsLoaded: boolean = false;
    areAvailableDocsLoaded: boolean = false;

    foundSelf: any = null;

    activeDocCount: number = 0;
    inactiveDocCount: number = 0;

    assignButtons: any = [];

    standbyTarget: any = null;
    genericDialog: MdsLax<InstanceType<typeof GenericDialog>> = null;

    kwittBookingContent: HTMLDivElement;
    kwittBookingFiles: HTMLDivElement;
    kwittBookingFilesContainer: HTMLDivElement;

    KWittCalendarMainWrapper: any; // (mds) was InstanceType<typeof KWitt_Main> — import dropped to break the KWitt ESM base-class cycle
    downloadTravelListBtnNode: HTMLElement;

    private _loadItemDetails(): void {
        let requestUrl = window.appRoot + "Calendar/GetItemDetailsWithFiles";
        this.StandbyStart();

        let data = {
            EntityId: this.itemId,

        }

        let requestParams = {
            'jsonData': JSON.stringify(data)
        };

        this.RequestManager.post(
            requestUrl,
            requestParams,
            lang.hitch(this, this._applyItemData),
            lang.hitch(this, this._onLoadListValuesError),
            false // sync
        );
    }

    setData(itemData: KWittCalendar_ItemDetails, bSuppressApply?: boolean): void {
        this.itemData = itemData;

        if (bSuppressApply === true) {
            return;
        }

        this._applyItemData(itemData);
    }

    private _applyItemData(itemData: KWittCalendar_ItemDetails): void{

        this.itemData = itemData;

        let content = this.itemData.content;
        this.UiModder.domAttr.set(this.kwittBookingContent, "innerHTML", content);

        if (this.itemData.filesDetails.length > 0) {

            this.UiModder.domClass.remove(this.kwittBookingFilesContainer, "w3-hide");
            
            this.itemData.filesDetails.forEach((file, i, arr) => {
                let node = this.UiModder.domConstruct.create("div", {
                    class: "w3-row w3-margin-bottom"
                }, this.kwittBookingFiles);
                let btn = new Button();

                btn.setLabel("Download");
                btn._onClick_Button = lang.hitch(this, "_onClick_Download", file);

                this.UiModder.domConstruct.create("div", {
                    class: "w3-col l9",
                    innerHTML: file.fileName
                }, node);

                btn.placeAt(this.UiModder.domConstruct.create("div", {
                    class: "w3-col l2"
                }, node));

                if (i === arr.length - 1) {
                    this.UiModder.domClass.remove(node, "w3-margin-bottom");
                }
            });
        }

        if (itemData.show_download_travel_list_button === true) {

            this.UiModder.domClass.remove(this.downloadTravelListBtnNode, "w3-hide w3-disabled");
        }

        this.StandbyStop();
    }
    _onClick_Download(file: KWittCalendar_FileDetails) {
        //console.log("_onClick_Download", entity);
        location.href = window.appRoot + "FileFinder/Download?downloadKey=" + file.downloadKey;
    }

    _onClick_DownloadTravelList() {

        let requestUrl = window.appRoot + "Calendar/RequestTravelListReport";
        this.StandbyStart();

        this.RequestManager.post(
            requestUrl, {
                entityId: this.itemId
            },
            lang.hitch(this, this._onDownloadTravelListResponse),
            lang.hitch(this, this._onDownloadTravelListError),
            false // sync
        );
    }

    _onDownloadTravelListResponse(response: { fileId: string }): void {

        this.StandbyStop();
        location.href = window.appRoot + "FileFinder/Download?downloadKey=" + response.fileId;
    }

    _onDownloadTravelListError(error): void {

        this.StandbyStop();

        this.KWittCalendarMainWrapper.publishToastMessage("Error during report request", ToasterHelpers.ToasterIcons.error, 5000, error.Message);
    }

    _onLoadListValuesError(error): void{
        this.areBookedDocsLoaded = true;

        this.KWittCalendarMainWrapper.publishToastMessage("Error loading information about event", ToasterHelpers.ToasterIcons.error, 0, error.Message);

        this.tryEndStandby();
    }


    reload(): void {

        this._loadItemDetails();
    }

    private tryEndStandby(): void {
        if (this.areAvailableDocsLoaded && this.areBookedDocsLoaded) {
            this.StandbyStop();
        }
    }
    

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this._standbyOverlay.target = this.standbyTarget; //??

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.reload();

    }    
}

export default mdsWidget(KWittBookingDetails);